import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@mui/styles';



const styles = makeStyles({
    button: {
        border: 'none',
        fontWeight: 600,
        textTransform: 'uppercase',
        fontSize: '14px',
        color: '#FFFFFF',
        textAlign: 'center',
        textDecoration: 'none',
        margin: '5px 5px',
        padding: '10px',
        borderRadius: '15px',
        direction: 'ltr',
        '&:hover': {
            cursor: 'pointer',
        }
    },
    primary: {
        backgroundColor: "#004B9E",
        '&:hover': {
            backgroundColor: "#006de6",
        }
    },
    large: {
        width: "200px"
    },
    medium: {
        width: "135px"
    },
    small: {
        width: "95px"
    },
    slim: {
        padding: '8px 18px'
    },
    icon: {
        width: "95px",
        marginRight: '8px',
        fontSize: '16px'
    }
});



interface ButtonProps {
    onClick: (event: React.SyntheticEvent<any>, reason: string) => void;
    size: 'large' | 'medium' | 'small' | 'slim';
    type: "primary"
    text: string;
    icon?: any;
    style?: {};
    disabled? : boolean;
}



export const Button = ({ icon, size, type, text, onClick, style, disabled }: ButtonProps) => {
    const classes = styles();
    
    return (
        <button className={`${classes.button} ${classes[type]} ${size ? classes[size] : "large"}`} onClick={(event) => onClick(event, 'click')} style={style} disabled={disabled}>
            {icon && <FontAwesomeIcon icon={icon} className={classes.icon} />}
            {text}
        </button>
    )
}



export default (Button);
